import React from "react";

const DeleteIcon = () => {
  return (
    <svg viewBox="0 0 22.75 23.97" class="button__icon">
      <defs></defs>
      <title>Asset 1</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_3" data-name="Layer 3">
          <path
            class="cls-1"
            d="M21.75,4.7H1a1,1,0,0,1,0-2H21.75a1,1,0,0,1,0,2Z"
          ></path>
          <path
            class="cls-1"
            d="M14,4.1a2.63,2.63,0,0,0-5.15,0l-2-.39a4.63,4.63,0,0,1,9.07,0L14,4.1Z"
          ></path>
          <path
            class="cls-1"
            d="M4.63,24a2,2,0,0,1-2-1.94L1.61,4.7a1,1,0,0,1,.94-1.06,1,1,0,0,1,1.06.94l1,17.33L18.12,22l1-17.39a1,1,0,0,1,2,.12L20.11,22a2,2,0,0,1-2,1.94H4.63Z"
          ></path>
          <path
            class="cls-1"
            d="M7.58,20.3a1,1,0,0,1-1-.94L5.92,7.44a1,1,0,1,1,2-.11l.67,11.92a1,1,0,0,1-.94,1.05Z"
          ></path>
          <path
            class="cls-1"
            d="M15.17,20.3h-.06a1,1,0,0,1-.94-1.05l.66-11.92a1,1,0,0,1,2,.11l-.67,11.92a1,1,0,0,1-1,.94Z"
          ></path>
          <path
            class="cls-1"
            d="M11.38,20.3a1,1,0,0,1-1-1V7.39a1,1,0,1,1,2,0V19.3a1,1,0,0,1-1,1Z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default DeleteIcon;